import React from "react";
import { useTranslation } from 'react-i18next';
import { Container } from "react-bootstrap";

const PrivacyPolicyScreen = () => {
  const { t } = useTranslation();

  return (
    <Container className="pb-3">
        <h3 className="py-4">{t('privacy_title')}</h3>
      
      <section className="pb-2">
        <h5>{t('data_collection_title')}</h5>
        <p>{t('data_collection_description')}</p>
      </section>
      
      <section className="pb-2">
        <h5>{t('data_usage_title')}</h5>
        <p>{t('data_usage_description')}</p>
      </section>
      
      <section className="pb-2">
        <h5>{t('data_sharing_title')}</h5>
        <p>{t('data_sharing_description')}</p>
      </section>
      
      <section className="pb-2">
        <h5>{t('user_rights_title')}</h5>
        <p>{t('user_rights_description')}</p>
      </section>
      
      <section className="pb-2">
        <h5>{t('data_protection_officer_title')}</h5>
        <p>{t('data_protection_officer_description')} contact@lmbrasil.com</p>
      </section>
    </Container>
  );
};

export default PrivacyPolicyScreen;
